module.exports = __webpack_public_path__ + "static/media/quite-impressed.c8e4cd20.mp3";